// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2zA9g","content":"LayoutSettings_content__2Dxw8"};